import { Controller } from 'stimulus'
import Choices from 'choices.js'

export default class extends Controller {

  connect () {
    if (!/android/i.test(navigator.userAgent) && !/iPad|iPhone|iPod/.test(navigator.userAgent) && !(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      this.select = new Choices(this.element, { shouldSort: false })
    } else {
      this.element.className = 'w-100 flex justify-center items-center pv2 ph3 no-outline input-reset f6 fw6 bg-white br1 ba b--black-20 dowpdown-arrow'
    }
  }

  disconnect () {
    // this.somethingELse.destroy()
  }
}

